import { fileExtensions } from "./fileExtensions";

export const getFileExtension = (name: string) => {
	const nameArr = name.split(".");
	const ext = nameArr[nameArr.length - 1];

	return fileExtensions.find(e => e.ext.toLowerCase() === ext.toLowerCase());
};
